import { toast } from "react-toastify";

export const toastMessageBox=(subject,message,type)=>{
    if(type==="danger"){
      toast.error(message, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000, // Adjust as needed
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          backgroundColor: '#dc3545', // Danger color
          color: '#fff', // Text color
        },
      });
    
    }
   else if(type==="warning"){
        toast.warn(message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 5000, // Adjust as needed
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            backgroundColor: '#FFA500', // Danger color
            color: '#fff', // Text color
          },
        });
      
      }
      else if(type==="success"){
        toast.success(message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 5000, // Adjust as needed
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            backgroundColor: '#008000',
            color: '#fff', // Text color
          },
        });
      
      }
  
  }